class DateRange {
    id: KnockoutObservable<number>;
    name: KnockoutObservable<string>;
    nextDate: KnockoutObservable<number>;
    previousDate: KnockoutObservable<number>;

    initials: KnockoutObservable<string>;
    startDate: KnockoutObservable<string>;
    endDate: KnockoutObservable<string>;

    validForSingleDate: KnockoutObservable<boolean>;

    constructor(data) {
        this.id = ko.observable(data.id);
        this.name = ko.observable(data.name);
        this.nextDate = ko.observable(data.nextDate);
        this.previousDate = ko.observable(data.previousDate);

        this.initials = ko.observable(data.initials);
        this.startDate = ko.observable(data.startDate);
        this.endDate = ko.observable(data.endDate);

        this.validForSingleDate = ko.observable(data.validForSingleDate);
    }
}